"use strict";

// Shows a shadow on the side of a table that can still be scrolled to
document.addEventListener("DOMContentLoaded", () => {
    const holders = document.querySelectorAll(".js-tableScroll");
    if (!holders.length) {
        return;
    }

    holders.forEach((holder) => {
        const scroller = holder.querySelector(".o-table__scroll");
        if (!scroller) {
            return;
        }

        const update = () => {
            const maxScroll = scroller.scrollWidth - scroller.clientWidth;
            holder.classList.toggle("-canScrollLeft", scroller.scrollLeft > 1);
            holder.classList.toggle("-canScrollRight", scroller.scrollLeft < maxScroll - 1);
        };

        scroller.addEventListener("scroll", update, { passive: true });

        if (typeof ResizeObserver !== "undefined") {
            new ResizeObserver(update).observe(scroller);
        } else {
            window.addEventListener("resize", update);
        }

        update();
    });
});
